import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

const Favicon = () => {
  // Initial state for the favicon
  const initMedia = {
    width: "100px",
    height: "100px",
    alternate: "default alt",
    description: "default description",
    path: "",
    link: "",
  };

  const [fav, setFav] = useState(initMedia);

  // Fetch other media from the Redux store
  const otherMedia = useSelector((state) => state.othermediaInformationListR?.data || {});

  // Get device type from local storage
  const deviceType = localStorage.getItem("device_type") || '';

  // Effect to update favicon data
  useEffect(() => {
    if (deviceType) {
      const faviconData = otherMedia?.['favicon']?.[0] || {};
      setFav((prevFav) => ({
        ...prevFav,
        description: faviconData.description || prevFav.description,
        alternate: faviconData.alternate || prevFav.alternate,
        path: faviconData.path || prevFav.path,
        link: faviconData.link || prevFav.link,
      }));
    }
  }, [otherMedia, deviceType]);

  // Effect to update favicon link in the document head
  useEffect(() => {
    const link = document.querySelector("link[rel~='icon']") || document.createElement("link");
    if (!link.href) {
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = fav.path || "/favicon.ico";
  }, [fav.path]);

  return null; // This component does not render anything to the DOM
};

Favicon.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(Favicon);
